module.exports = __webpack_public_path__ + "assets/img/c42a20b51e55365b7d37a5974a9e658e.png";